<template>
    <div class="ad-slider">
        
        <div v-if="ads && $leseapp.useads">
            <div v-if="!timer && speed">{{ slide(speed) }}</div>
            <a href='#' v-bind:alt='ad.title' v-on:click="goto(ad.id, ad.group_id, ad.sched_id, ad.link)">
                <img v-bind:src="ad.image">
            </a>
        </div>
      
    </div>    
</template>

<script>
export default {
    name: "Adslider",
    props: {
        ads: Array,
        speed: Number,
        postId: Number
    },
    created() {
        this.index = 0;        
    },
    beforeDestroy() {
        //this.$log.debug('destroy', this.ads);
        this.destroyed = true;
    },
    data() {
        return {
            index: Number,
            ad: Array,
            timer: false,
            destroyed: false
        };
    },    
    methods: {       
        goto(id, groupId, timerId, link) {
            this.$log.debug("Forwarding to " + id + " / " + link);
            this.$ms.apiAdrotateClick(this, id, groupId, timerId, link);            
        },
        slide(seconds) {   
            var self = this;
            this.timer = true;
            if (this.$ms.hasElements(this.ads) && !this.destroyed) {
                this.$log.debug('ads', this.ads, 'speed', this.speed);
                this.ad = this.ads[this.index];
                this.index++;            
                if (this.index >= this.$ms.countElements(this.ads))
                    this.index = 0;
                setTimeout(function() { 
                    self.slide(seconds) 
                }, seconds * 1000);
            }            
        },
    }
};
</script>

<style lang="css" src="../assets/css/Adslider.css"/>